<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_vi"></a>Copyright © 1996 by Jack Womack</p>
<p class="copyright">All rights reserved. No part of this book may be reproduced<br/>in any form or by any electronic or mechanical means, including<br/>information storage and retrieval systems, without permission in<br/>writing from the publisher, except by a reviewer, who may quote<br/>brief passages in a review.</p>
<p class="copyright"><em>Published simultaneously in Canada<br/>Printed in the United States of America</em></p>
<p class="copyright1">The Library of Congress has cataloged the hardcover edition as follows:<br/>Womack, Jack.<br/>     Let’s put the future behind us / Jack Womack. — 1st ed.<br/>         p. cm.<br/>    1. Businessmen—Russia (Federation)—Moscow—Fiction. I. Title.<br/>   PS3573.0575L48      1996<br/>   813′.54—dc.20                                                  95-43552<br/>     eBook ISBN-13: 978-1-5558-4760-9</p>
<p class="copyright1">Grove Press<br/>841 Broadway<br/>New York, NY 10003</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0bdd2013